import "reflect-metadata"; //needed for class-transformer

import "./styles/utility-sheet";
// uno resets and utilities for the page itself, so only entries that own the
// page load it (not the integration entry). Generated and untracked:
// eslint-disable-next-line import/no-unresolved
import "./styles/uno.css";

import "./elements/app";

import { initApp } from "./init";

initApp({ mode: "standalone" });

const app = document.createElement("ptc-app");
document.body.appendChild(app);
